import React, { useState, useEffect } from 'react'
import { Link, navigate } from 'gatsby'
import './HoverContainer.scss'
import { GatsbyImage } from 'gatsby-plugin-image'

interface HoverProps {
  property: any
  image: any
  openModal?: any
  floorArea?: string
  index?: number
}

const HoverContainer = (props: HoverProps): JSX.Element => {
  const {
    property: { propertyUnits, propertyDetails, slug, description },
    image,
    openModal,
    floorArea,
    index
  } = props

  const isPropertyPage = propertyUnits === undefined

  const imageAltText = isPropertyPage
    ? props?.property?.altText ?? 'Property image'
    : propertyUnits?.[0]?.overviewDetails?.imagesGallery?.[0]?.altText ?? propertyUnits?.[0]?.overviewDetails?.overviewDetails?.title

  const [isDragged, setIsDragged] = useState<boolean>(false)

  useEffect(() => {
    document.addEventListener('mousedown', () => setIsDragged(false))
    document.addEventListener('mousemove', () => setIsDragged(true))
  }, [])

  const projectDetails = isPropertyPage ? (
    <>
      <p>Total Floor Area</p>
      <p>Approx. {floorArea} meters</p>
      <a onClick={(e) => e.preventDefault()}>View Floorplan</a>
    </>
  ) : (
    <>
      <h2 dangerouslySetInnerHTML={{ __html: propertyUnits[0].overviewDetails?.overviewDetails?.title }} />
      <p dangerouslySetInnerHTML={{ __html: propertyDetails?.terrain }} />
      <Link to={`/our-portfolio/${slug}/`}>View more</Link>
    </>
  )

  return (
    <div
      className={`hoverable ${isPropertyPage && 'propertyPageHeight'}`}
      onClick={(e) => {
        e.stopPropagation()
        !isDragged && !isPropertyPage && navigate(`/our-portfolio/${slug}/`)
        !isDragged && isPropertyPage && openModal(index, description)
      }}
    >
      {isPropertyPage ? (
        <img loading="lazy" src={image} alt={imageAltText} />
      ) : (
        <GatsbyImage className="carousel-image-portfolio" image={image} alt={imageAltText} />
      )}
      <div className="img-description">
        <ul>{projectDetails}</ul>
      </div>
    </div>
  )
}

export default HoverContainer
